'use client'
import type { PageReadinessState } from '@brew/observability/browser'
import { type ReactNode, Suspense, useEffect } from 'react'
import { usePageContentReadiness } from '@/hooks/use-page-content-readiness'
import { pageCommit } from '@/lib/observability/page-commit'
import type { PAGE_CONTENT_CONTRACTS } from '@/lib/observability/page-content-contracts'
import { pageContentReadiness } from '@/lib/observability/page-content-readiness'
import { pageReadiness } from '@/lib/observability/page-readiness'

type Props = {
  pageKey:
    | keyof typeof PAGE_CONTENT_CONTRACTS
    | ReadonlyArray<keyof typeof PAGE_CONTENT_CONTRACTS>
  part: string
  state: PageReadinessState
  children?: ReactNode
}
function Observer({ pageKey, part, state }: Omit<Props, 'children'>) {
  usePageContentReadiness(pageKey, state, { part })
  return null
}
/** Place at the real content branch, never outside its loading/error decision. */
export function PageContentReady({ children, ...props }: Props) {
  return (
    <>
      {children}
      <Suspense fallback={null}>
        <Observer {...props} />
      </Suspense>
    </>
  )
}

/** The committed Next 404 fallback closes pending gates without claiming a page rendered. */
export function PageUnavailable(): null {
  useEffect(() => {
    pageCommit.unavailable()
    pageContentReadiness.unavailable()
    pageReadiness.unavailable()
  })
  return null
}
